import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CirrusInputDirective } from './directives/cirrus-input.directive';
import { InputPrefixDirective } from './directives/input-prefix.directive';
import { InputSuffixDirective } from './directives/input-suffix.directive';
import { LabelHelperDirective } from './directives/label-helper.directive';

import { CirrusFieldWrapperComponent } from './cirrus-field-wrapper.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  exports: [
    CirrusFieldWrapperComponent,
    InputPrefixDirective,
    InputSuffixDirective,
    LabelHelperDirective,
    CirrusInputDirective
  ],
  declarations: [
    CirrusFieldWrapperComponent,
    InputPrefixDirective,
    InputSuffixDirective,
    LabelHelperDirective,
    CirrusInputDirective
  ]
})
export class CirrusFieldWrapperModule {}
